import React, { Component } from 'react';
import { any, string, func, shape, arrayOf, oneOf } from 'prop-types';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';

import TimeRangeSelector from './TimeRangeSelector';

import classNames from 'classnames';
import styles from "./styles.scss";

const initialSelectChartSeries = {
  showBaseSerie: true,
  showAdditionSerie: true,
  showGuidelineSerie: true
}

class DataSelector  extends Component {
  static propTypes = {
    classes: shape({any}),
    className: string,
    typeOptions: arrayOf(shape({
      value: string,
      label: string
    })),
    selectedOptions: shape({
      type: string,
      timeRange: oneOf(['hourly', 'daily', 'weekly', 'monthly', 'byDayOfWeek', 'byDayPart'])
    }),
    onSelectionChange: func
  }

  static defaultProps = {
    typeOptions: [{
      value: 'adVisit',
      label: 'Total Ad Visits'
    },
    {
      value: 'newAdUsers',
      label: 'New Ad Users'
    }],
    selectedOptions: {
      type: 'adVisit',
      timeRange: 'hourly'
    }
  }

  handleTypeChange = event => {
    const {
      selectedOptions,
      onSelectionChange
    } = this.props;

    const type = event.target.value;
    onSelectionChange && selectedOptions.type !== type &&
    onSelectionChange({type, ...initialSelectChartSeries});
  }

  handleTimeRangeChange = value => {
    const {
      selectedOptions,
      onSelectionChange
    } = this.props;

    onSelectionChange && selectedOptions.timeRange !== value &&
    onSelectionChange({timeRange: value, ...initialSelectChartSeries});
  }

  drawTypeSelector() {
    const {
      classes,
      typeOptions,
      selectedOptions
    } = this.props;

    const selectedType = selectedOptions && selectedOptions.type || typeOptions[0].value;
    
    return (
      <FormControl className={styles.dropdown}>
        <Select
          value={selectedType}
          className={styles.selectItem}
          onChange={this.handleTypeChange}
          inputProps={{ classes: { icon: classes.arrowDropDown } }}
          data-test="selectType"
        >
          {
            typeOptions.map(type => <MenuItem value={type.value} key={type.value} data-test="selectTypeOption">{type.label}</MenuItem>)
          }
        </Select>
      </FormControl>
    );
  }

 
  
  render () {
    const {className, selectedOptions} = this.props;
    return (
      <div className={classNames(styles.dataSelector, className)}>
        {this.drawTypeSelector()}
        <TimeRangeSelector
          selectedRange={selectedOptions.timeRange}
          onTimeSelectionChange={this.handleTimeRangeChange}
        />
      </div>
    )
  }
}

const muiStyles = {
  arrowDropDown: {
    color: '#2196f3'
  }
};
export default withStyles(muiStyles)(DataSelector);